import React from 'react';
import Form from './components/Form';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';


function Contact() {

    return (
        <div className='bg-light'>
            <Form />
            <div className='bs-contact-info'>
                <div className='bs-contact-info__img-wrap'>
                    <CloudinaryAdvancedImage imagePublicId="Rectangle_1_fts36b.jpg" className='bs-contact-info__image' type="info-hero-banner" />
                </div>
                <div className='bs-contact-info__info-wrap'>
                    <h2 className='cm-title'>CONTACT US</h2>
                    <p className='bs-contact-info__desc'>
                        <span className='cm-line-break cm-semi-bold'>Headquarters</span>
                        D'Decor Curtain Fabrics LLP<br />
                        S14, Solitaire Corporate Park, 5th Floor,
                        167, Guru Hargovindji Marg, Chakala,
                        Andheri (E) Mumbai – 400093, India
                    </p>
                    <p className='bs-contact-info__desc'><a href="mailto:support@sansaar.co.in">Email: support@sansaar.co.in</a></p>
                    <p className='bs-contact-info__desc'><a href="tel:7208026067">Mobile: 72080 26067</a></p>
                </div>
            </div>
        </div>
    )
}

export default Contact